// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/558329b3222e71efd667.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"5e19f4868f9d4a993055","129":"2c82f723023dd2630fea","130":"bbdfca7104f85c462247"}[chunkId] + ".chunk.js";
};